import CommentIcon from '@/public/icons/comments.svg';
import React, { ReactNode } from 'react';
import {
  AuthorLayout,
  CommentLayout,
  StyledComment,
  StyledComments,
  StyledContent,
  StyledDepartment,
  StyledFilter,
  StyledHour,
  StyledName,
  StyledTitle,
  TitleLayout,
  RecordingBadge,
  UploadFailureBadge,
} from '@/components/MobileApproval/Content/styles';
import {
  FavoriteChecked,
  FavoriteDefault,
} from '@/theme/overrides/CustomIcons';
import ProfilesImages from '@/components/MobileApproval/Content/ProfilesImages';
import { useTranslation } from 'react-i18next';
import AlertIcon from '@/public/icons/alert.svg';
import { SpinningIcon } from '@/components/Approval/RightContainer/ApprovalContent/TitleInfo/styles';
type P = {
  docId: string;
  totalCount: number;
  filterColor: { color: string; borderColor: string; background: string };
  filterName: string;
  subject: string;
  rightTopContent: ReactNode;
  profiles: string[];
  author: string;
  departmentName: string;
  createAt: string;
  commentInfo: { author?: string; comment?: string };
  handleClick: (docId: string) => void;
  isBookmarked: boolean;
  handleBookmark?: (docId: string, isBookmarked: boolean) => void;
  isRecording?: boolean;
  haveErrorRecording?: boolean;
  isLoading?: boolean;
};

const Content = ({
  docId,
  totalCount,
  filterColor,
  filterName,
  subject,
  rightTopContent,
  author,
  departmentName,
  createAt,
  profiles,
  commentInfo,
  handleClick,
  isBookmarked,
  handleBookmark,
  isRecording,
  haveErrorRecording,
  isLoading,
}: P) => {
  const { i18n } = useTranslation();
  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    handleBookmark?.(docId, isBookmarked);
  };
  const stripHTML = (html?: string) => {
    if (!html) return null;
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  };

  return (
    <StyledContent
      type={'button'}
      onClick={() => handleClick(docId)}
      isRecording={isRecording}
      haveErrorRecording={haveErrorRecording}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          width: '100%',
          gap: '8px',
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center',
          }}
        >
          <StyledFilter colorSet={filterColor}>
            {isLoading && <SpinningIcon />}
            {filterName}
          </StyledFilter>
          {isRecording && <RecordingBadge>REC</RecordingBadge>}
          {haveErrorRecording && (
            <UploadFailureBadge>
              <AlertIcon /> 업로드 실패
            </UploadFailureBadge>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {rightTopContent}
          {handleBookmark && (
            <button
              style={{ display: 'flex', padding: '3px' }}
              onClick={onClick}
              aria-label={isBookmarked ? '즐겨찾기 해제' : '즐겨찾기 추가'}
            >
              {isBookmarked ? (
                <FavoriteChecked width={18} height={18} />
              ) : (
                <FavoriteDefault width={18} height={18} />
              )}
            </button>
          )}
        </div>
      </div>
      <TitleLayout>
        <StyledTitle>{subject}</StyledTitle>
      </TitleLayout>
      <AuthorLayout>
        <ProfilesImages docId={docId} profiles={profiles} />
        <StyledName>
          {author}
          {i18n.language === 'ko' && (
            <StyledDepartment>{departmentName}</StyledDepartment>
          )}
        </StyledName>
        <StyledHour>{createAt}</StyledHour>
      </AuthorLayout>
      {totalCount > 0 && (
        <CommentLayout>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <CommentIcon />
            <StyledComments>{totalCount}</StyledComments>
          </div>
          {commentInfo && (
            <StyledComment>
              <span style={{ color: 'var(--dk-text, black)' }}>
                {commentInfo.author + ' : '}
              </span>

              <span style={{ color: 'var(--dk-text-secondary, #888D96)' }}>
                {stripHTML(commentInfo.comment)}
              </span>
            </StyledComment>
          )}
        </CommentLayout>
      )}
    </StyledContent>
  );
};

export default Content;
